import { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router';
import PopupModal from './PopupModal';
import { API_BASE_URL } from '../utils/apiConfig';

export default function PopupScheduler() {
  const location = useLocation();
  const [visible, setVisible] = useState([]);
  const timeouts = useRef([]);

  useEffect(() => {
    timeouts.current.forEach(clearTimeout);
    timeouts.current = [];

    setVisible([]);

    const url = `${API_BASE_URL}/api/popups?path=${encodeURIComponent(location.pathname)}`;

    fetch(url)
        .then(res => {
            if (!res.ok) {
                return res.text().then(txt => {
                    throw new Error(`HTTP ${res.status}: ${txt || res.statusText}`);
                });
            }
            return res.json();
        })
        .then((data) => {
            if (!Array.isArray(data)) {
                console.warn('Popup endpoint did not return an array:', data);
                return; 
            }

            const seen = JSON.parse(sessionStorage.getItem("seenPopups") || "[]");

            data.forEach(p => {
                if (seen.includes(p.popupId)) return;
                const delaySec = Number(p.appearanceTime) || 0;
                const timerId = window.setTimeout(() => {
                    setVisible(prev => [...prev, p]);
                }, delaySec * 1000);

                timeouts.current.push(timerId);
            });
        })
        .catch(err => {
            console.error('Failed to load popups:', err);
        });
    }, [location.pathname]);

const handleClose = (id) => {
  setVisible(prev => prev.filter(p => p.popupId !== id));

  const seen = JSON.parse(sessionStorage.getItem("seenPopups") || "[]");
  sessionStorage.setItem("seenPopups", JSON.stringify([...seen, id]));
};

  return (
    <>
        {visible.map(p => (
            <PopupModal
                key={p.popupId}
                id={p.popupId}
                name={p.popupName}
                message={p.popupMessage}
                type={p.popupType}
                responses={p.responses}
                image={p.image}
                linkPage={p.linkPage}
                secondaryMessage={p.secondaryMessage}
                secondaryResponses={p.secondaryResponses}
                isDismissible={p.isDismissible}
                onClose={() => handleClose(p.popupId)}
            />
        ))}
    </>
  )
}